export default __webpack_public_path__ + "static/media/nv_sir.42640196.png";